import { LeafletOsmProvider } from './map-provider-osm.js';

document.addEventListener('DOMContentLoaded', () => {
    const mapEl = document.getElementById('chipmap-detail-map');
    if (!mapEl) {
        return;
    }

    const provider = mapEl.dataset.provider === 'google' ? null : new LeafletOsmProvider();
    if (!provider) {
        console.warn(`Chip Mäp: Kartenanbieter "${mapEl.dataset.provider}" ist noch nicht implementiert.`);
        return;
    }

    const lat = parseFloat(mapEl.dataset.lat);
    const lng = parseFloat(mapEl.dataset.lng);

    provider.init(mapEl, {
        tileUrl: mapEl.dataset.tileUrl,
        attribution: mapEl.dataset.attribution,
        centerLat: lat,
        centerLng: lng,
        zoom: 15,
    });

    provider.addMarker({
        lat,
        lng,
        name: mapEl.dataset.name || '',
        color: mapEl.dataset.color || '',
        popupHtml: mapEl.dataset.name || '',
    });
});
